var map = {
	"./decoracao_01.jpg": 146,
	"./decoracao_02.jpg": 147,
	"./decoracao_03.jpg": 148,
	"./decoracao_04.jpg": 149,
	"./decoracao_05.jpg": 150,
	"./decoracao_06.jpg": 151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 297;